import { Routes, Route } from "react-router-dom";
import Layout from "../layout";
import Login from "../pages/auth/login";
import AdminDashboard from "../pages/adminDashboard";
import Branches from "../pages/adminDashboard/settings/branches";
import BranchForm from "../pages/adminDashboard/settings/branches/form";
import { useSelector } from "react-redux";
import Settings from "../pages/adminDashboard/settings";
import Docs from "../pages/docs";
import PatientManagement from "../pages/adminDashboard/patient-management/index";
import EncountersList from "../pages/adminDashboard/encounters";
import PatientEncounters from "../pages/adminDashboard/patient-management/PatientEncounters";
import PatientDocuments from "../pages/adminDashboard/patient-management/PatientDocuments";
import EncounterEditor from "../pages/emr/EncounterEditor";
import EditProfile from "../pages/adminDashboard/editProfile";
import Forgotpassword from "../pages/auth/forgotpassword";
import Newpassword from "../pages/auth/newpassword";
import UserManagement from "../pages/adminDashboard/users";
import AuditLog from "../pages/adminDashboard/auditLog";
import PermissionSettings from "../pages/adminDashboard/settings/permissions";

function Routing() {
    const { isLoggedIn } = useSelector((state) => state.auth);
    return (
        <Routes>
            <Route element={<Layout layoutName="admin" proctedRoute={true} />}>
                <Route path=":role">
                    <Route index element={<AdminDashboard />} />
                    <Route path="edit-profile" element={<EditProfile />} />
                    <Route path="patient-management" element={<PatientManagement />} />
                    <Route path="encounters" element={<EncountersList />} />
                    <Route path="patients/:patientId/encounters" element={<PatientEncounters />} />
                    <Route path="patients/:patientId/encounters/:encounterId" element={<EncounterEditor />} />
                    <Route path="patients/:patientId/documents" element={<PatientDocuments />} />
                    <Route path="users" element={<UserManagement />} />
                    <Route path="settings">
                        <Route index element={<Settings />} />
                        <Route path="branches" element={<Branches />} />
                        <Route path="permissions" element={<PermissionSettings />} />
                        <Route path="audit-log" element={<AuditLog />} />
                    </Route>
                </Route>
            </Route>

            <Route element={<Layout layoutName="auth" />}>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<Forgotpassword />} />
                <Route path="/new-password/:token" element={<Newpassword />} />
            </Route>

            <Route element={<Layout layoutName="auth" />}>
                <Route path="/" element={<Login />} />
                <Route path="*" element={<Login />} />
            </Route>

            <Route element={<Layout />}>
                <Route path="/docs" element={<Docs />} />
            </Route>

            {isLoggedIn && <Route path="add/branch" element={<BranchForm onlyForm={true} />} />}
        </Routes>
    )
}

export default Routing;
